// src/features/chat/components/MessageActions.jsx

import React, { memo, useCallback } from 'react';
import { Reply } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import styles from './MessageActions.module.css';

const MessageActions = memo(function MessageActions({
  onReply,
  visible = false,
  variant = 'received',
}) {
  const { t } = useTranslation();

  const handleReply = useCallback(
    (event) => {
      event.stopPropagation();
      onReply?.();
    },
    [onReply]
  );

  if (!onReply) return null;

  return (
    <div
      className={styles.actionsContainer}
      data-variant={variant}
      data-visible={visible}
    >
      <div className={styles.actionsBar}>
        <button
          type="button"
          className={styles.actionButton}
          onClick={handleReply}
          aria-label={t('chat.reply', 'Reply')}
          title={t('chat.reply', 'Reply')}
        >
          <Reply size={16} />
        </button>
      </div>
    </div>
  );
});

MessageActions.displayName = 'MessageActions';

export default MessageActions;
